import { createSlice } from '@reduxjs/toolkit';

import type { MockupSizeRange } from '@/domain/mockup/mockupSizeRangeTypes';

const initialState: MockupSizeRange = {
  sizes: [],
};

const mockupSizeRangeSlice = createSlice({
  name: 'mockupSizeRange',
  initialState,
  reducers: {
    clear: state => {
      state.sizes = [];
    },
  },
});

export const { clear } = mockupSizeRangeSlice.actions;

export const mockupSizeRangeReducer = mockupSizeRangeSlice.reducer;
